import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-telegram",
  "use": "icon-telegram-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-telegram\"><path d=\"M8.027 12.386l-.303 4.188c.434 0 .622-.183.847-.403l2.034-1.909 4.216 3.031c.773.423 1.317.2 1.526-.698l2.767-12.729c.246-1.123-.413-1.561-1.166-1.286L1.684 8.693c-1.11.423-1.093 1.03-.188 1.306l4.158 1.27 9.658-5.934c.454-.295.868-.132.528.164l-7.813 6.887z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol